export default "__VITE_ASSET__BNu$7Ysa__"